import { SearchPayloadForRecords } from "../models/Authorization";
import API from "./api";
export const PostAllPatientRecord = (configUrl: string, payload: SearchPayloadForRecords) => {
  return API.post(`${configUrl}api/patients/patientRecords`, payload);
};
export const GetPatientHeader = (
  configUrl: string,
  patientId: number,
  referralID: number,
) => {
  return API.get(
    `${configUrl}api/patients/patientdetail/${patientId}/${referralID}`
  );
};
